// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V4_Y0UUZM8Mpl0pcarzu{flex-direction:column;gap:16px;display:flex}.J8DAaiUX02EtHgLMQzfQ{padding-top:8px}.OEcX6X9oQnkVQgaMkHhD{flex-direction:column;gap:4px;display:flex}.dF30ssyI0M7awVufNBgr{padding-left:12px}.zqdFudjAfEgOdwRZejLJ{margin-left:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `V4_Y0UUZM8Mpl0pcarzu`,
	"wrapName": `J8DAaiUX02EtHgLMQzfQ`,
	"wrapField": `OEcX6X9oQnkVQgaMkHhD`,
	"input": `dF30ssyI0M7awVufNBgr`,
	"cancelButton": `zqdFudjAfEgOdwRZejLJ`
};
export default ___CSS_LOADER_EXPORT___;
